<div class="section-title">History</div>
@if (dataLoaded) {
    <mat-accordion multi>
        <mat-expansion-panel
            [attr.data-uiid]="'incident-history-mutation-header'"
            [expanded]="false"
            [hideToggle]="true"
            [disabled]="true"
        >
            <mat-expansion-panel-header class="default-cursor">
                <mat-panel-title><span class="mutation-header">Name</span></mat-panel-title>
                <mat-panel-description
                    ><span class="mutation-header">Date and time</span></mat-panel-description
                >
                <mat-panel-title>
                    <span class="mutation-header">Status</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel>
        @for (mutation of mutations; track $index; let odd = $odd, even = $even) {
            <mat-expansion-panel
                [attr.data-uiid]="'incident-history-mutation-' + $index"
                (opened)="onMutationOpened(mutation)"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title
                        ><span class="mutation-user" [title]="mutation.userName">
                            {{ mutation.userName }}</span
                        ></mat-panel-title
                    >
                    <mat-panel-description
                        ><span class="mutation-item">{{
                            mutation.dateChange | dateTimeDisplay: true : true
                        }}</span></mat-panel-description
                    >
                    <mat-panel-title>
                        <span class="mutation-item">{{ mutation.status }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @if (mutation.changes && mutation.changes.length > 0) {
                    <!-- create an overview to show the changes-->

                    @for (change of mutation.changes; track $changeIndex) {
                        <div class="change-container">
                            <label class="change-label">
                                {{ change.propertyName }}
                            </label>
                            <div class="change-row-item">
                                <span class="change-field-value">
                                    {{ change.oldValue }}
                                </span>
                                <mat-icon class="small" fontSet="material-icons-outlined"
                                    >keyboard_arrow_right</mat-icon
                                >
                                <span class="change-field-value">
                                    {{ change.newValue }}
                                </span>
                            </div>
                        </div>
                    } @empty {
                        <p>Loading changes</p>
                    }
                }
            </mat-expansion-panel>
        }
    </mat-accordion>
} @else {
    <p>Loading.</p>
}
